import axios from "axios";
import { jsonHeader } from '../util/GeneralUtil'
import * as BullCache from "../util/BullCache";

const apiUrl = process.env.REACT_APP_API_URL;
// const trueDataApiUrl = process.env.REACT_APP_TRUEDATA_API_URL;

var user = BullCache.getFromCache("user");

async function getSocketConfigs(payload) {
    const result = await axios.post(apiUrl + "/socket/get", payload, {
        headers: jsonHeader}
    );
    return result.data || [];
}

async function reload(payload) {
    const result = await axios.post(apiUrl + "/socket/reload", payload, {
        headers: jsonHeader}
    );
    return result.data || [];
}

async function updateSocketConfig(payload) {
    const result = await axios.post(apiUrl + "/socket/update", payload, {
        headers: jsonHeader}
    );
    return result.data || [];
}

async function changeStatus(payload) {
    const result = await axios.post(apiUrl + "/socket/changestatus", payload, {
        headers: jsonHeader}
    );
    return result.data || [];
}

// async function trueDataReload(payload) {
//     const result = await axios.post(trueDataApiUrl + "/socket/reload", payload, {
//         headers: jsonHeader}
//     );
//     return result.data || [];
// }

export const SocketConfigService = {
    getSocketConfigs,
    updateSocketConfig,
    changeStatus,
    reload,
    //trueDataReload
}